import styled from 'styled-components';

export const Wrapper = styled.div<{ isSuperAdmin: boolean }>`
  padding-top: 80px;
  padding-left: ${({ isSuperAdmin }) => (isSuperAdmin ? '108px' : '88px')};
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 100vh;
  min-height: 100dvh;
`;

export const LoaderWrapper = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: #fff;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  animation: fade-in 0.4s forwards;
`;

export const FooterWrapper = styled.div`
  position: fixed;
  bottom: 34px;
  left: 0;
  right: 0;

  @media all and (max-height: 850px) {
    position: relative;
    bottom: 0px;
    left: 0;
    right: 0;
    width: 100%;
  }
`;

export const DisabledFeatureWrapper = styled.div`
  text-align: center;
  color: rgb(28 35 44 / 60%);
  padding: 0 36px;
  max-width: 400px;
  margin: 0 auto;
  margin-top: 100px;
`;

export const DisabledFeatureTitle = styled.p`
  color: var(--colorBlueGray1200);
  font-size: 1.5em;
  font-weight: bold;
  margin-bottom: 10px;
`;
